<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M0 0h50v50H0z" style="opacity:.002;fill:#cc5ccc" fill="currentColor"/><path d="M9.288 4A4.288 4.288 0 0 0 5 8.288V38.7a4.288 4.288 0 0 0 4.288 4.288h25.731a4.288 4.288 0 0 0 4.289-4.288V8.288A4.288 4.288 0 0 0 35.019 4z" style="opacity:.45;fill:#cc5ccc" transform="translate(2.797 2.238)" fill="currentColor"/><path d="M25.186 12.919a1.365 1.365 0 0 1 .4 1.889l-7.579 11.584a1.364 1.364 0 0 1-2.175.145l-4.233-4.9a1.364 1.364 0 0 1 2.065-1.784l3.049 3.53L23.3 13.314a1.365 1.365 0 0 1 1.886-.395z" style="fill-rule:evenodd;fill:#cc5ccc" transform="translate(6.305 7.104)" fill="currentColor"/><path d="M0 0h18v9H0z" style="fill:#cc5ccc" transform="translate(16 3)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodcategory08',
});
</script>
